<script>
  import {External, M} from "../../external";
  import {onDestroy, onMount} from "svelte";
  import { extractResolutionsFromM3U8, getAspectRatio, loadPlayerScripts } from '../static';

  const CONTAINER_ID = 'test-video-content-edit';
  const TYPE_VERTICAL = 'VERTICAL', TYPE_SQUARE = 'SQUARE', TYPE_HORIZONTAL = 'HORIZONTAL';

  export let popup = {};

  export let video;
  export let contentOverlay = {
    name: '',
    showAt: 0,
    hideAt: 5,
    content: '',
    layoutClass: 'center',
    backgroundColor: '#fff',
    fullHeight: false
  };
  //video player
  let player;
  //showAt and hideAt JQuery slider
  let showHideSlider;
  //full height checkbox can be applied only on right or left bottom layout
  let disableFullHeight = ['center', 'bottom'].includes(contentOverlay.layoutClass);
  //widget grid for content overlay
  let grid;

  let contentOverlayPopupElementId = 'content-overlay-' + video.elementId;
  let gridContainerId = 'grid-container-' + video.elementId;
  let layoutClasses = ['none', 'center', 'right-bottom', 'left-bottom', 'bottom'];

  let selectedLayoutStyle = layoutClasses.indexOf(contentOverlay.layoutClass);
  let videoDuration = Math.floor(video.durationInMs / 1000);
  let videoType = TYPE_HORIZONTAL;


  onMount(() => {
    if (!contentOverlay.content) {
      contentOverlay.content = '[]';
    }
    setBackgroundColor();
    showHideSlider = External.$('#showHideAtContentOverlaySlider').slider({
      range: true,
      min: 0,
      max: videoDuration,
      values: [contentOverlay.showAt, contentOverlay.hideAt],
      slide: function (event, ui) {
        let showAt = ui.values[0];
        let hideAt = ui.values[1];
        if (showAt === hideAt) {
          if (hideAt >= 1) {
            showAt = hideAt - 1;
          } else {
            hideAt = showAt + 1;
          }
        }
        player.currentTime = showAt;
        contentOverlay.showAt = showAt;
        contentOverlay.hideAt = hideAt;
      }
    });
    extractResolutionsFromM3U8(video.videoPath)
      .then(resolutions => {
        let dimensions = resolutions[1].split('x');
        let width = parseInt(dimensions[0]);
        let height = parseInt(dimensions[1]);
        if (width === height) {
          videoType = TYPE_SQUARE;
        } else if (height > width) {
          videoType = TYPE_VERTICAL;
        }
        loadVideoPlayer(width, height);
      });
  });

  onDestroy(() => {
    if (grid) {
      // contentOverlay.content = JSON.stringify(grid.getSaveObject().widgets);
      grid.destroy();
    }
  })

  let setMarkup = (parent) => {
    if (contentOverlay.content && contentOverlay.content.length > 4) {
      renderWidget(contentOverlay.content, parent);
    } else {
      setupGrid();
    }
  }

  let setBackgroundColor = () => {
    let bgColorUI = External.$('#videoContentOverlayBgColor');
    let bgColor = contentOverlay.backgroundColor ? contentOverlay.backgroundColor : 'transparent';
    External.Tools.addColorPicker(bgColor, bgColorUI.prev(), bgColorUI, (color, colorClass) => {
      let hexColorVal = External.Tools.rgbaToHexNoAlpha(color);
      contentOverlay.backgroundColor = hexColorVal;
      updatePopup();
    });
  }

  let setLayoutStyle = (style) => {
    // contentOverlay.content = JSON.stringify(grid.getSaveObject().widgets);
    let container = External.$('#' + contentOverlayPopupElementId);
    container.removeClass(contentOverlay.layoutClass);
    selectedLayoutStyle = style;
    switch (style) {
      case 2:
      case 3:
        disableFullHeight = false;
        break;
      default:
        contentOverlay.fullHeight = false;
        disableFullHeight = true;
    }
    if (!contentOverlay.fullHeight) {
      container.removeClass("full-height");
    }
    container.addClass(layoutClasses[style]);
    contentOverlay.layoutClass = layoutClasses[style];
  }

  let addPopup = () => {
    let parent = document.querySelector('#video-' + video.elementId).parentElement;

    let contentOverlayContainer = document.createElement('div');
    contentOverlayContainer.id = contentOverlayPopupElementId;
    contentOverlayContainer.style.zIndex = 2;
    contentOverlayContainer.classList.add("video-content-overlay");
    if (contentOverlay.fullHeight) {
      contentOverlayContainer.classList.add("full-height");
    }
    contentOverlayContainer.style.backgroundColor = contentOverlay.backgroundColor;
    contentOverlayContainer.classList.add(contentOverlay.layoutClass);
    let contentOverlaySection = document.createElement('section');
    contentOverlaySection.id = 'section' + contentOverlayPopupElementId;
    contentOverlaySection.classList.add("working-area-wrapper");
    contentOverlaySection.classList.add("popup-content");
    let plyBtnContainer = document.createElement('div');
    plyBtnContainer.id = gridContainerId;
    contentOverlaySection.appendChild(plyBtnContainer);
    contentOverlayContainer.prepend(contentOverlaySection);
    parent.prepend(contentOverlayContainer);
    setMarkup(plyBtnContainer);
  }

  let updatePopup = () => {
    let existingPopup = document.getElementById(contentOverlayPopupElementId);
    if (existingPopup) {
      existingPopup.remove();
      addPopup();
    }
  }

  let onFullHeightChecked = () => {
    contentOverlay.fullHeight = !contentOverlay.fullHeight;
    updatePopup();
  }

let close = () => {
    if (grid.getSaveObject().widgets.length > 0) {
      contentOverlay.content = JSON.stringify(grid.getSaveObject().widgets);
      popup.close();
    } else {
      External.Tools.showError(M.ADD_CONTENT_TO_OVERLAY, 2000);
    }
  }
  
  let validateShowAt = (event) => {
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
    if (event.target.value === '') {
      contentOverlay.showAt = 0;
    } else {
      contentOverlay.showAt = parseInt(event.target.value);
    }
    if (contentOverlay.showAt < 0) {
      contentOverlay.showAt = 0;
    } else if (contentOverlay.showAt >= contentOverlay.hideAt) {
      contentOverlay.showAt = contentOverlay.hideAt - 1;
    } else if (contentOverlay.showAt >= videoDuration) {
      contentOverlay.showAt = videoDuration - 1;
    }
    showHideSlider.slider( "values", 0, contentOverlay.showAt );
    player.currentTime = contentOverlay.showAt;
  }
  
  let validateHideAt = (event) => {
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
    if (event.target.value === '') {
      contentOverlay.hideAt = 5;
    } else {
      contentOverlay.hideAt = parseInt(event.target.value);
    }
    if (contentOverlay.hideAt > videoDuration) {
      contentOverlay.hideAt = videoDuration;
    } else if (contentOverlay.hideAt <= contentOverlay.showAt) {
      contentOverlay.hideAt = contentOverlay.showAt + 1;
    } else if (contentOverlay.hideAt === contentOverlay.showAt) {
      contentOverlay.hideAt = contentOverlay.showAt + 1;
    }
    showHideSlider.slider( "values", 1, contentOverlay.hideAt );
  }

  let setupGrid = () => {
    let gridContainer = document.getElementById(gridContainerId);
    grid = External.Grid(External.$(gridContainer), {
      inPopup: true,
      disableHistoryKeyboardBindings: false,
      forceDesktopMode: true,
      showNewWidgetUiAtRight: true,
      hasAnchorPoints: false,
      widgetFilter: (item) => {
        if (
            (item.type === External.WIDGET_TYPE.CATEGORY && item.value === M.WIDGET_CATEGORY_COMPLEX) ||
            (item.type === External.WIDGET_TYPE.WIDGET && item.value === "Container") ||
            item.type === External.WIDGET_TYPE.COMPLEX_WIDGET
        ) {
          return false;
        }
        return true;
      },
    });
  };

  let addWidget = (event) => {
    if (grid) {
      grid.showAddWidgetDialog(event);
    }
  };

  let renderWidget = async (content, parent) => {
    External.Tools.makeWebsiteRequest({
      action: 'renderWidgets',
      method: 'post',
      data: {
        widgets: content
      },
      onOk: function (result) {
        parent.innerHTML = result.data;
        setupGrid();
      }
    });
  }

  let loadVideoPlayer = (videoWidth, videoHeight) => {
    loadPlayerScripts(() => {
      let videoElement = document.getElementById('video-' + video.elementId);
      if (videoType !== TYPE_HORIZONTAL) {
        let container = videoElement.closest('.video-inner-wrapper');
        container.style.width = videoWidth + 'px';
        container.style.height = videoHeight + 'px';
        container.style.margin = 'auto';
      }
      if (window.Hls.isSupported()) {
        let hslConfig = {
          //length in seconds
          maxBufferLength: 1,
          //length in seconds
          maxMaxBufferLength: 1,
          //size in bytes
          maxBufferSize: 1 * 1000 * 1000,
        };
        let hls = new window.Hls(hslConfig);
        hls.loadSource(video.videoPath);
        hls.attachMedia(videoElement);
      }
      let plyrOptions = {
        // title: videoTitle,
        ratio: getAspectRatio(video.width, video.height),
        settings: ['speed', 'loop'],
        controls: [],
        clickToPlay: false,
        fullscreen: {enabled: false},
      };
      if (video.captions && video.captions.length > 0) {
        plyrOptions.settings.push('captions');
        for (const caption of videoCaptions) {
          let track = document.createElement('track');
          track.kind = 'captions';
          track.label = caption.lang;
          track.srclang = caption.tag;
          track.src = caption.url;
          videoElement.appendChild(track);
        }
        plyrOptions['captions'] = {
          active: true,
          language: videoCaptions[0].tag
        }
      }
      player = new window.Plyr(videoElement, plyrOptions);
      player.on('ready', event => {
        player.toggleControls(false);
      });
      player.on('loadeddata', event => {
        player.currentTime = contentOverlay.showAt;
      });
      //this event is called on every update but also when video loads
      player.on('timeupdate', event => {
        let currSec = Math.floor(player.currentTime);
        let existingPopup = document.getElementById(contentOverlayPopupElementId);
        if (currSec >= contentOverlay.showAt && currSec < contentOverlay.hideAt && !existingPopup) {
          addPopup();
        } else if (currSec < contentOverlay.showAt || currSec >= contentOverlay.hideAt) {
          if (existingPopup) {
            existingPopup.remove();
          }
        }
      });
    });
  }

  let selectAllOnFocus = (event) => {
    event.target.select();
  }

</script>

<div data-force-right="false" data-width="1200" data-title="false">
  <div class="full-size flex flex-row-col-responsive">
    <div id="{CONTAINER_ID}" class="flex-none member-subnav filter-nav" style="width: 295px;">
      <div class="popup-widget-wrapper smaller">
        <h4 class="col20 f-left mt-35 mb-25 t-left h4-bigger" style="padding: 0;">{M.CONTENT_SETTINGS}</h4>
        <div class="popup-input-wrapper">
          <h5>{M.CONTENT_NAME}</h5>
          <input bind:value={contentOverlay.name} type="text" name="videoContentName" placeholder={M.ENTER_CONTENT_NAME}>
        </div>
        <div class="popup-input-wrapper">
          <div id="showHideAtContentOverlaySlider">
          </div>
        </div>
        <div class="popup-input-wrapper col9n">
          <h5>{M.SHOW_AT}</h5>
          <input bind:value={contentOverlay.showAt} on:blur={validateShowAt} on:focus={selectAllOnFocus} id="contentOverlayShowAtInp" type="number" name="showTime" placeholder="">
        </div>
        <div class="popup-input-wrapper col9n f-right">
          <h5>{M.HIDE_AT}</h5>
          <input bind:value={contentOverlay.hideAt} on:blur={validateHideAt} on:focus={selectAllOnFocus} id="contentOverlayHideAtInp" type="number" name="hideTime" placeholder="">
        </div>
        <ul class="option-select container-type modal-select mb-15">
          <li class:active={selectedLayoutStyle === 1} on:click={() => setLayoutStyle(1)}><a class="modal-center transition-bg"><span></span></a></li>
          <li class:active={selectedLayoutStyle === 2} on:click={() => setLayoutStyle(2)}><a class="modal-bottom-right transition-bg"><span></span></a></li>
          <li class:active={selectedLayoutStyle === 3} on:click={() => setLayoutStyle(3)}><a class="modal-bottom-left transition-bg"><span></span></a></li>
          <li class:active={selectedLayoutStyle === 4} on:click={() => setLayoutStyle(4)}><a class="modal-bottom transition-bg"><span></span></a></li>
        </ul>
        <div class="input-wrapper input-wrapper-small color-pick-wrap-widgets" style="margin-bottom:10px;">
          <div class="color-pick-wrap">
            <div></div>
            <input type="text" value="" class="colorpicker-selected modify" id="videoContentOverlayBgColor"  name="bgColor">
          </div>
          <div class="info">
            <h5>{M.BACKGROUND_COLOR}</h5>
          </div>
        </div>
<!--        show full height option only for bottom side layout-->
        {#if selectedLayoutStyle === 2 || selectedLayoutStyle === 3}
          <div class="checkbox-wrapper col20 f-left">
            <input on:click={onFullHeightChecked} id="makeFullHeight" bind:checked={contentOverlay.fullHeight}
                   class="css-checkbox" type="checkbox" disabled="{disableFullHeight}">
            <label for="makeFullHeight" class="css-label">{M.MAKE_FULL_HEIGHT}</label>
          </div>
        {/if}
      </div>
    </div>
    <div class="overflow horizontal-flex-table relative flex align-center justify-center">

<!--      <section>-->
<!--        <div  id="mileVoliDisko"></div>-->
<!--&lt;!&ndash;      <div class="desktop-view flex flex-col" use:setupGrid>&ndash;&gt;-->
<!--        &lt;!&ndash;{@html builderMarkup}&ndash;&gt;-->
<!--&lt;!&ndash;      </div>&ndash;&gt;-->
<!--&lt;!&ndash;      <a on:click={(event) => addWidget(event)} class="middle-button blue with-icon add-widget-video-content relative">Add Widget</a>&ndash;&gt;-->
<!--      </section>-->
      <div class="video-content-wrapper">
        <div class="col20 f-left flex space-between">
<!--          <a on:click={(event) => addWidget(event)} class="middle-button blue with-icon add-widget-video-content relative">Add Widget</a>-->
          <a on:click={(event) => addWidget(event)} class="middle-button blue with-icon add-widget-video-content relative">{M.ADD_WIDGET}</a>
          <div>
            <a on:click={close} class="f-left middle-button gray add-widget-video-content relative mr-5">{M.CLOSE}</a>
            <a on:click={close} class="f-left middle-button blue add-widget-video-content relative">{M.SAVE_AND_CLOSE}</a>
          </div>
        </div>
        <div class="video-inner-wrapper" id="videoContentOverlayContainer">
          <video id='video-{video.elementId}' controls crossorigin playsinline >
          </video>
        </div>
      </div>
    </div>
  </div>
</div>

<!--<style>-->
<!--/*&lt;!&ndash;    background: url(https://dcev90o3tr0bn.cloudfront.net/s/0083928578378921/uploads/__client_uploads__/wall-1714683870134-pfrm_expl_unsplsh-kyt0PkBSCNQ-1835259-4825006.webp?format=webp) center center;&ndash;&gt;*/-->
<!--    .video-content-overlay {-->
<!--        position: absolute;-->
<!--        padding: 35px;-->
<!--        background: #fff;-->
<!--        box-shadow: 0 0 31px 0 rgb(71 81 99 / 6%);-->
<!--    }-->

<!--    .video-content-overlay.right-bottom {-->
<!--        bottom: 0;-->
<!--        right: 0;-->
<!--    }-->

<!--    .video-content-overlay.left-bottom {-->
<!--        bottom: 0;-->
<!--        left: 0;-->
<!--    }-->

<!--    .video-content-overlay.full-height {-->
<!--        top: 0;-->
<!--    }-->

<!--    .video-content-overlay.bottom {-->
<!--        bottom: 0;-->
<!--        left: 0;-->
<!--        right: 0;-->
<!--    }-->

<!--    .video-inner-wrapper {-->
<!--        position: relative;-->
<!--        border-radius: 10px;-->
<!--    }-->

<!--    .video-content-overlay.center {-->
<!--        -webkit-transform: translate(-50%, -50%);-->
<!--        -moz-transform: translate(-50%, -50%);-->
<!--        transform: translate(-50%, -50%);-->
<!--        top: 50%;-->
<!--        left: 50%;-->
<!--    }-->
<!--</style>-->
